import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-users-view',
    templateUrl: './users-view.component.html',
    styleUrls: ['./users-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UsersViewComponent implements OnChanges {
    @Input() users: any[];
    @Input() searchUser: string;
    @Input() noAssignUsers: boolean;
    @Input() allUsersSelected: boolean;
    @Input() selectedUser: any;
    @Input() radioDisabled: boolean;
    @Input() errors: {
        org: string[];
        user: string[];
    };

    @Output() searchUserChange = new EventEmitter();
    @Output() clearSearchUsers = new EventEmitter();
    @Output() searchAssignUsers = new EventEmitter();
    @Output() selectAllUsers = new EventEmitter();
    @Output() checkUsersList = new EventEmitter();

    computedRadioOptions: any[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['users'] || changes['searchUser'] || changes['radioDisabled']) {
            this.updateComputedOptions();
        }
    }

    public updateComputedOptions(): void {
        if (!this.users) {
            this.computedRadioOptions = [];
            return;
        }

        const search = this.searchUser?.toLowerCase().trim() || '';
        const filteredUsers = this.users.filter(user => {
            if (!search) return true;
            const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase().trim();
            const email = user.email?.toLowerCase() || '';
            return fullName.includes(search) || email.includes(search);
        });

        const sortedUsers = filteredUsers.sort((a, b) => a.firstName.localeCompare(b.firstName));

        this.computedRadioOptions = sortedUsers.map(user => ({
            displayName: `${user.firstName} ${user.lastName}`,
            value: user,
            disabled: this.radioDisabled,
            checked: user?.checked,
        }));
    }
}
